import { render, staticRenderFns } from "./StoreImage.vue?vue&type=template&id=21a2573a&scoped=true&"
import script from "./StoreImage.vue?vue&type=script&lang=js&"
export * from "./StoreImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2573a",
  null
  
)

export default component.exports